/* eslint-disable no-unused-vars */
export enum useBookingEnum {
  DeviceWidth = 500,
  MaxDatesOnStrip = 13,
  MinDatesOnStrip = 7,
}

export enum slotType {
  ReservationSlots = "reservation-slots",
  TimeSlots = "time-slots",
}

export enum conditionalStyle {
  Disabled = "disabled",
  None = "",
}

export enum localKeys {
  SLOT = "slot",
}

export enum vatHandlingType {
  EXCLUSIVE = "EXCLUSIVE",
  INCLUSIVE = "INCLUSIVE",
}
